import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/angular-wallet-base/services/auth.service';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'app-stripe-order',
  templateUrl: './stripe-order.component.html',
  styleUrls: ['./stripe-order.component.scss'],
})
export class StripeOrderComponent implements OnInit {
  creditCardForm: FormGroup;
  asset = 'AGX';
  totalFiatAmonut = 0;
  userCurrency = 'USD';
  buttonClicked = false;

  constructor(private formBuilder: FormBuilder, private nav: NavController, private authService: AuthService) {}

  ngOnInit() {
    this.creditCardForm = this.formBuilder.group({
      amount: [null, [Validators.required, Validators.min(1)]],
    });
  }

  goBack() {
    const previousUrl = this.authService.getPreviousUrl();
    if (previousUrl.includes('/home-page/established') || previousUrl.includes('/buy-assets/')) {
      this.nav.navigateRoot(['/home-page/established']);
    } else {
      this.nav.back();
    }
  }

  onAmountChange(event: any) {
    this.calculateEstimatedCost();
  }

  calculateEstimatedCost() {}

  getMinValue() {
    return 1;
  }

  onSubmit() {}

  navigateToHomePage() {
    this.nav.navigateRoot(['/home-page/established']);
  }
}
